<template>
  <div
    class="prevent-select grid-view-item"
    @click="navigateToNode"
    @keydown.enter.prevent="navigateToNode"
    @keydown.space.prevent="navigateToNode"
    role="link"
    tabindex="0"
  >
    <div class="d-flex justify-center icon">
      <v-icon class="icon">mdi-folder</v-icon>
    </div>

    <div class="item-name mt-2">
      <v-tooltip location="bottom" open-delay="200" :aria-label="node.name">
        <template v-slot:activator="{ props }">
          <div v-bind="props" class="text-truncate">
            <span class="accesslink-grid-item-name">
              {{ node.name }}
            </span>
          </div>
        </template>
        <span>{{ node.name }}</span>
      </v-tooltip>
    </div>

    <div class="d-flex mt-2">
      <div class="d-flex flex-grow-1 align-center item-attributes">
        <div>{{ isoToDatetime(node.updatedat) }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import { isoToDatetime } from '@/components/formatters.js';

export default {
  name: 'AccesslinkGridNodeItem',
  methods: {
    isoToDatetime,
    navigateToNode() {
      this.$router.push({ name: 'accesslink:view:node', params: { nodeid: this.node.id } });
    },
  },
  components: {},
  props: {
    node: {
      type: Object,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
  },
}
</script>


<style lang="scss" scoped>
.icon {
  width: 200px !important;
  height: 112px !important;

  > i {
    font-size: 86px !important;
  }
}
</style>
